import { IEditorProps } from "components/props-interfaces";
import { config } from "config";
import { IDirectorySpec } from "data/directory-spec";
import { makeSiteRelative } from "utility";
import _ from 'lodash';

export function directoryEditorLister(props: IEditorProps): IEditorProps[] {
    const listing: IDirectorySpec = JSON.parse(props.text);
    if (props.operation === 'new') {
        return [{
            ...props,
            text: '',
            mimeType: listing.mimeTypes[0] || ''
        }];
    }
    
    const editorsProps = (listing.configs || []).flatMap(configSpec => {
        const configPath = makeSiteRelative(configSpec.url);
        const configResourceName = _.last(configPath.split('/'));
        const createLocalPath = configPath.startsWith('/' + props.path) ? '' : props.path + configResourceName;
        const schemaEditor: IEditorProps = {
            ...props,
            path: makeSiteRelative(configSpec.url),
            mimeType: 'application/schema+json',
            text: '',
            options: { fullPath: true, createLocalPath, deleteButton: configSpec.exists },
            operation: configSpec.exists ? '' : 'new'
        };
        const editors = [ schemaEditor ];
        return editors;
    });

    if (props.service && props.service.apisSupported.indexOf('urlFile') >= 0) {
        editorsProps.push({
            ...props,
            mimeType: 'application/zip'
        });
    }

    return editorsProps;
}